<template>
  <div>

  </div>
</template>

<script>

export default {
  name: 'Land',
  props: {
    activityId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  },
  methods: {

  },
  mounted() {
    if (!this.activityId == '') {
      const that = this
      this.$store.dispatch('activity/setId', this.activityId)
        .then(function () {
          that.$router.replace({name: 'login'})
        })
    }
  }
}
</script>
